import { Card } from "@/components/ui/Card";
import { formatLabel as defaultFormatLabel } from "@/constants/filters";
import type { BreakdownBucket } from "@/types";

interface BreakdownSectionProps {
  title: string;
  buckets: BreakdownBucket[];
  formatLabel?: (label: string) => string;
}

function getAccuracyColor(accuracy: number): string {
  if (accuracy >= 75) return "bg-green-500";
  if (accuracy >= 50) return "bg-yellow-500";
  return "bg-red-500";
}

function getAccuracyTextColor(accuracy: number): string {
  if (accuracy >= 75) return "text-green-700";
  if (accuracy >= 50) return "text-yellow-700";
  return "text-red-700";
}

export function BreakdownSection({
  title,
  buckets,
  formatLabel = defaultFormatLabel,
}: BreakdownSectionProps) {
  if (buckets.length === 0) return null;

  return (
    <Card>
      <h3 className="mb-4 text-sm font-medium uppercase tracking-wider text-gray-500">
        {title}
      </h3>
      <div className="space-y-4">
        {buckets.map((bucket) => (
          <div key={bucket.label}>
            <div className="mb-1.5 flex items-center justify-between">
              <span className="text-sm font-medium text-gray-900">
                {formatLabel(bucket.label)}
              </span>
              <div className="flex items-center gap-2">
                <span className="text-xs text-gray-500">
                  {bucket.correct}/{bucket.total}
                </span>
                <span className={`text-sm font-bold ${getAccuracyTextColor(bucket.accuracy)}`}>
                  {bucket.accuracy}%
                </span>
              </div>
            </div>
            <div className="h-2.5 overflow-hidden rounded-full bg-gray-100">
              <div
                className={`h-full rounded-full transition-all ${getAccuracyColor(bucket.accuracy)}`}
                style={{ width: `${bucket.accuracy}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
